import React from 'react';

const ProfilePlaceHolder = () => (
  <div className="media profile profile-placeholder" />
);

export default ProfilePlaceHolder;



// WEBPACK FOOTER //
// ./src/components/MapInfoBar/ParkingSpotInfoDetail/ProfilePlaceHolder.js